import { LoyaltyOverviewGridView } from '~/components/loyalty/overview';
import { PageContainer } from '~/components/page-container';

export function LoyaltyOverview() {
	return (
		<PageContainer>
			<LoyaltyOverviewGridView />
		</PageContainer>
	);
}
